import { render, staticRenderFns } from "./CryptoPriceChart.vue?vue&type=template&id=a1a83d2c&"
import script from "./CryptoPriceChart.vue?vue&type=script&lang=js&"
export * from "./CryptoPriceChart.vue?vue&type=script&lang=js&"
import style0 from "./CryptoPriceChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports